/* eslint-disable no-unused-vars */
import { useState, useEffect } from "react";
import Button from "../../../components/Buttons/Button";
import { useSelector } from "react-redux";
import { getDeviceInfoById } from "../../../state/ducks/ble/bleService";
import { fwuFile as fwuFile_131_5_0 } from "../../../services/fwu/131_5_0";
import { fwuFile as fwuFile_131_7_1 } from "../../../services/fwu/131_7_1";
import { fwuFile as fwuFile_21_4_0 } from "../../../services/fwu/21_4_0";
import { fwuFile as fwuFile_21_5_0 } from "../../../services/fwu/21_5_0";
import DeviceFwuClient from "../../../services/fwu/deviceFwuClient";

const fwVersions = {
    131_5_0: "131.5.0",
    131_7_1: "131.7.1",
    21_4_0: "21.4.0",
    21_5_0: "21.5.0",
}

const FwuUpdateModal = ({ id }) => {

    const [timer, setTimer] = useState(0);
    const [isUpdating, setIsUpdating] = useState(false);
    const [isError, setIsError] = useState(false);
    const [selectedFwuFile, setSelectedFwuFile] = useState(null);
    const [statusMessage, setStatusMessage] = useState()

    const deviceInfo = useSelector(getDeviceInfoById(id));

    useEffect(() => {
        let interval = null;
        if (isUpdating) {
            interval = setInterval(() => {
                setTimer((timer) => timer + 1);
            }, 1000);
        } else if (!isUpdating && timer !== 0) {
            clearInterval(interval);
        }

        if (isUpdating && !statusMessage && timer > 30 && !isError) {
            setIsError('Timeout error')
            resetProgress()
        }
        return () => clearInterval(interval);
    }, [isUpdating, timer]);

    const resetProgress = () => {
        setTimer(0);
        setStatusMessage(null);
        setIsUpdating(false);
    }

    const onFirmwareUpdateStartHandler = async () => {
        setIsError(false);
        setIsUpdating(true);
        const deviceFwuClient = new DeviceFwuClient({
            deviceId: id,
            fwuPackageData: selectedFwuFile,
            sendStatusMessage: (message) => {
                console.log("sendStatusMessage: ", message);

                if (message?.status?.progress) {
                    setStatusMessage(message.status.progress + '%')
                } else {
                    setStatusMessage(message);
                }
            },
            onUpgradeProcessing: () => {
                resetProgress();
                alert("Start Upgrade Processing. Please wait until the device reboots ...");
            },
            onError: (error) => {
                setIsError(error);
                resetProgress();
            }
        });

        await deviceFwuClient.startFwUpdate();

        console.warn("##################  START FIRMWARE UPDATE ################## ")
    };

    const formatTime = (time) => {
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time - (hours * 3600)) / 60);
        const seconds = time - (hours * 3600) - (minutes * 60);

        return [hours, minutes, seconds]
            .map(v => v < 10 ? "0" + v : v)
            .filter((v, i) => v !== "00" || i > 0)
            .join(":");
    }

    const handleSelectChange = (e) => {
        switch (e.target.value) {
            case fwVersions[131_5_0]:
                setSelectedFwuFile(fwuFile_131_5_0);
                break;
            case fwVersions[131_7_1]:
                setSelectedFwuFile(fwuFile_131_7_1);
                break;
            case fwVersions[21_4_0]:
                setSelectedFwuFile(fwuFile_21_4_0);
                break;
            case fwVersions[21_5_0]:
                setSelectedFwuFile(fwuFile_21_5_0);
                break;
            default:
                setSelectedFwuFile(null);
        }
    }

    const getStatusPercentage = (statusMessage) => {
        if (!statusMessage) {
            return null;
        }

        const match = statusMessage.match(/\d+/);
        const number = match ? parseInt(match[0], 10) : null;
        return number >= 1 && number <= 100 ? number : null;
    }

    const percentage = getStatusPercentage(statusMessage);


    return (
        <div className="flex flex-col w-full h-full py-20 px-4">
            <header className="h-16">
                <h1 className="text-4xl ">Update Firmware</h1>
            </header>
            <p>Current version: {deviceInfo?.firmware || "---"}</p>
            <div className="flex flex-col mt-6">
                <label className="flex  flex-col">
                    Select available FW version:
                    <select className="my-4" name="selectedFruit" onChange={handleSelectChange}>
                        <option value="">Select version</option>
                        <option value={fwVersions[131_5_0]}>{fwVersions[131_5_0]}</option>
                        <option value={fwVersions[131_7_1]}>{fwVersions[131_7_1]}</option>
                        <option value={fwVersions[21_4_0]}>{fwVersions[21_4_0]}</option>
                        <option value={fwVersions[21_5_0]}>{fwVersions[21_5_0]}</option>
                    </select>
                </label>
            </div>

            {isError && <div className="text-red-500">Error: {isError}</div>}

            <div className="h-full flex flex-col justify-between">
                <div>
                    {isUpdating &&
                        <>
                            <div className="flex w-full mt-6">
                                <span>Time Spent Uploading: <b>{formatTime(timer)}</b> </span>
                            </div>

                            <div className="w-full flex flex-col items-center pt-10 relative">
                                <p className="mb-2 absolute mt-[8px] text-white">{statusMessage ? statusMessage : 'Uploading firmware...'}</p>
                                <progress className="w-full h-10" value={percentage || 0} max={100}></progress>
                            </div>
                        </>}
                </div>

                <div className="flex flex-col">
                    <Button
                        className="text-black border border-gray-500"
                        isDisabled={!selectedFwuFile || isUpdating}
                        onClick={onFirmwareUpdateStartHandler}>{isError ? "Retry Firmware Update" : "Start Firmware Update"}
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default FwuUpdateModal;